import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Globle } from 'src/assets/globle';
import { Messages } from '../messages.model';
import { OptionService } from '../option.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css'],
  queries: {
    contentRef: new ViewChild("Modal"),
    contentRef1: new ViewChild("ModalView"),
    contentRef2: new ViewChild("ModalViewImg"),
    contentRef3: new ViewChild("ModalConfirmReject")
  },
})
export class MessagesComponent implements OnInit {

  messages: Messages[] = [];
  displayedColumns: string[] = ['date', 'fullName', 'mobileNo', 'messageText', 'imageUrl', 'view', "delete"];
  dataSource!: MatTableDataSource<Messages>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  public contentRef!: TemplateRef<any>;
  public contentRef1!: TemplateRef<any>;
  public contentRef2!: TemplateRef<any>;
  public contentRef3!: TemplateRef<any>;
  message: Messages = {} as Messages;
  messageType: { id: number, name: string }[] = [{ id: 0, name: "all" }, { id: 1, name: "directCharged" }, { id: 2, name: "others" }];
  chargedStatus: { id: number, name: string }[] = [{ id: -1, name: "all" }, { id: 1, name: "chargedDone" },
  { id: 0, name: "notCharged" }, { id: 2, name: "rejected" }];
  selectedStatus: number = -1;
  selectedMessageType: number = 0;
  message_text!: string;
  imgView!: string;
  rejectReason: string = "";
  id: any;
  pageSize = 100;

  constructor(private service: OptionService,
    private snackBar: MatSnackBar,
    private globle: Globle,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.pageSize = this.globle.pageSize;
    this.getMessages();

    //setInterval(() => { this.getMessages(); }, 180000);

  }

  getMessages() {
    this.spinnerOverlay = true;
    //this.selectedMessageType, this.selectedStatus
    this.service.getMessages().subscribe(data => {
      this.messages = data.sort((n1, n2) => n2.id - n1.id);
      this.dataSource = new MatTableDataSource(this.messages);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  edit(item: any) {
    this.message_text = item.message;
    this.openDialogView();
  }

  onDelete(id: number) {
    this.message.id = id;
    this.openDialog();
  }

  delete() {
    this.spinnerOverlay = true;
    this.dialog.closeAll();
    this.service.deleteMessages(this.message.id).subscribe(data => {
      this.openSnackBar("Deleted successfully", 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getMessages();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("Internal server error", "snackBarError");
        }
      })
  }

  confirmDelete() {
    this.delete();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  openDialogView(): void {
    const dialogRef = this.dialog.open(this.contentRef1, {
      width: '500px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  viewImg(img: any) {
    this.imgView = img;
    this.openDialogImg();

  }

  openDialogImg(): void {
    const dialogRef = this.dialog.open(this.contentRef2, {
      width: '1000px',
      height: '1000px'
    });
  }

  openDialogReject(): void {
    const dialogRef = this.dialog.open(this.contentRef3, {
      width: '250px',
      height: '250px'
    });
  }

  onChargedDone(id: number) {
    this.spinnerOverlay = true;
    this.service.updateStatusMessage(id, 1, "").subscribe(data => {
      this.openSnackBar("تم التعديل بنجاح", 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getMessages();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("حدث خطأ بالنظام", "snackBarError");
        }
      })

  }

  onMessageTypeChange() {
    if (this.selectedMessageType == 2) {
      this.displayedColumns = ['date', 'fullName', 'mobileNo', 'messageText', 'imageUrl', 'view', "delete"];
    }
    else {
      this.displayedColumns = ['date', 'fullName', 'mobileNo', 'messageText', 'imageUrl', 'view', 'updateStatus', 'reject', "delete"];
    }
    this.getMessages();
  }

  onReject(id: number) {
    this.id = id;
    this.openDialogReject();
  }

  confirmReject() {
    this.spinnerOverlay = true;
    this.service.updateStatusMessage(this.id, 2, this.rejectReason).subscribe(data => {
      this.openSnackBar("تم التعديل بنجاح", 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getMessages();
      this.dialog.closeAll();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("حدث خطأ بالنظام", "snackBarError");
        }
      })
  }

}
